import React from "react";

const Branch = ({ header, title, phones, emails, swift, address }) => (
  <div className="branches-item">
    <div className="branches-item__inner">
      <div className="branches-item__header">
        <font>
          <font>{header}</font>
        </font>
      </div>
      <div className="branches-item__body">
        <div className="branches-item__body-title">
          <font>
            <font>{title}</font>
          </font>
        </div>
        <div className="branches-phones">
          <p>
            {phones.map(({ type, number }) => (
              <a href={`${type}:${number}`}>
                <i className={type == "tel" ? "i-phone-alt" : "i-fax"}></i>
                <font>
                  <font>{number}</font>
                </font>
              </a>
            ))}
          </p>
          <p>
            {emails.map((email) => (
              <a href={`mailto:${email}`}>
                <i className="i-envelope-alt"></i>
                <font>
                  <font>{email}</font>
                </font>
              </a>
            ))}
          </p>
        </div>
        <p>
          <font>
            <font>{swift}</font>
          </font>
        </p>
        <p>
          <small>
            <font>
              <font dangerouslySetInnerHTML={{ __html: address }}></font>
            </font>
          </small>
        </p>
      </div>
    </div>
  </div>
);

export default Branch;
